/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import * as SelectPrimitive from "@radix-ui/react-select";
import type { ComponentRef } from "react";
import * as React from "react";

import type { ThemeType } from "../../../../../global/emotion";
import {
  radius,
  spacing,
  stroke,
  useTheme,
  zIndices,
} from "../../../../../global/emotion";
import { SelectScrollDownButton } from "./SelectScrollDownButton.emotion";
import { SelectScrollUpButton } from "./SelectScrollUpButton.emotion";

const contentStyle: Interpolation<ThemeType> = (theme) => ({
  backgroundColor: theme.semanticColors.onOverlayBackground,
  borderColor: theme.semanticColors.neutralsLowest,
  borderRadius: radius.l,
  borderStroke: stroke.regular,
  borderStyle: "solid",
  color: theme.semanticColors.primary,
  maxHeight: "var(--radix-select-content-available-height)",
  minWidth: "100px",
  overflow: "hidden",
  padding: spacing.s,
  position: "relative",
  zIndex: zIndices.modalContent,
});

type SelectContentProps = React.ComponentPropsWithoutRef<
  typeof SelectPrimitive.Content
>;

export const SelectContent = React.forwardRef<
  ComponentRef<typeof SelectPrimitive.Content>,
  SelectContentProps
>(({ children, ...props }, ref) => {
  const { themeContainerRef } = useTheme();
  return (
    <SelectPrimitive.Portal container={themeContainerRef.current}>
      <SelectPrimitive.Content ref={ref} css={contentStyle} {...props}>
        <SelectScrollUpButton />
        <SelectPrimitive.Viewport>{children}</SelectPrimitive.Viewport>
        <SelectScrollDownButton />
      </SelectPrimitive.Content>
    </SelectPrimitive.Portal>
  );
});

SelectContent.displayName = "SelectContent";
